import styled from '@emotion/styled';

export const SidebarWrapper = styled.aside`
  z-index: 99;
  height: auto;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const SidebarPolicyLinks = styled.div<{ isOpen: boolean }>`
  z-index: 100;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  align-items: center;
  width: auto;
  font-size: 12px;
  position: absolute;
  bottom: 0px;
  color: ${({ theme }) => theme.utils.getColor('primary', 400, 'normal')};
  display: flex;
  flex-direction: column;
  > a {
    padding-bottom: 8px;
  }
  max-width: 308px;
`;

export const PolicyWrapper = styled.span`
  padding: ${({ theme }) => theme.spacing.xl};
`;

export const PolicyParagraph = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSizes['12']};
  font-weight: ${({ theme }) => theme.typography.weights.regular};

  color: ${({ theme }) => theme.utils.getColor('secondary', 600, 'text')};
  a {
    color: ${({ theme }) => theme.utils.getColor('primary', 400, 'normal')};
  }
`;

export const PrivacyPolicyContainer = styled.div<{ expanded: boolean }>`
  width: 220px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  padding: 0 ${({ theme }) => theme.spacing.xl};
`;

export const PrivacyPolicyLink = styled.a`
  color: ${({ theme }) => theme.utils.getColor('primary', 400, 'normal')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
